import { Component, contentChild, HostListener, input, output, TemplateRef } from "@angular/core";
import { NgTemplateOutlet } from "@angular/common";
import { TranslatePipe } from "@ngx-translate/core";
import { SvgIconComponent } from "@kernel/tools/svg-icon/components/svg-icon/svg-icon.component";
import { IIconConfig } from "@kernel/shared/interfaces/icon-config.interface";

@Component({
  selector: "sxw-overlay-menu-item",
  imports: [NgTemplateOutlet, TranslatePipe, SvgIconComponent],
  templateUrl: "./overlay-menu-item.component.html",
  styleUrl: "./overlay-menu-item.component.scss",
  host: {
    class: "overlay-item",
    "[style]": "overlayItemStyles()",
  },
})
export class OverlayMenuItemComponent {
  label = input<string>();
  icon = input<IIconConfig>();
  overlayItemStyles = input<Record<string, unknown>>();
  itemClicked = output<void>();

  menuItemContent = contentChild<TemplateRef<void>>("menuItem", { descendants: false });

  @HostListener("click", ["$event"])
  clickItem(event: MouseEvent): void {
    event.stopPropagation();
    this.itemClicked.emit();
  }
}
